import React, { useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Image, Tag, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined, LinkOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../common";

interface Contentdata {
  key?: string;
  _id: number;
  id?: number;
  title?: string;
  image?: string;
  label?: string;
  link?: string;
  sheduledDate?: any;
}

interface DataTableProps {
  setshowModel: (value: boolean) => void;
  setEditable: (value: boolean) => void;
  deleteFeatured: (value: any) => void;
  editContent: (value: any) => void;
  isOpen: boolean;
  contentData: Contentdata[];
  showModal: any;
}
function DataTableFeatured({
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteFeatured,
  editContent,
  showModal,
}: DataTableProps) {
  const [searchText, setSearchText] = useState("");

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 100,
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a, b) => (a._id || a.id || 0) - (b._id || b.id || 0),
      onFilter: (value, record) => {
        return (
          String(record._id || record.id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record.label).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Title",
      dataIndex: "label",
      key: "label",
      width: 250,
      render: (text) => (
        <>
          <p dangerouslySetInnerHTML={{ __html: text.slice(0, 100) }} />
        </>
      ),
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <Space size="middle">
          <Image src={record.image} width={60} height={60} alt={"image"} />
        </Space>
      ),
    },
    
    {
      title: "Label",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      render: (_, record) => (
        <Space size="middle">
          <a
            className="table_pill_btn table_pill_btn--view"
            href={record.link}
            target="_blank"
            rel="noreferrer"
          >
            <LinkOutlined /> Click
          </a>
        </Space>
      ),
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Status",
      dataIndex: "sheduledDate",
      key: "sheduledDate",
      render: (_, record) => (
        <Space size="middle">
          {record.sheduledDate === null ? (
            <Tag color={"green"}>Published</Tag>
          ) : moment().format("YYYY-MM-DD") >= record.sheduledDate ? (
            <Tag color={"green"}>Published</Tag>
          ) : (
            <Tag color={"red"}>Not Published</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              setshowModel(!isOpen);
              setEditable(true);
              editContent(record._id || record.id);
            }}
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popover
            content={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "green",
                    width: "100%",
                    color: "#fff",
                  }}
                  onDoubleClick={() => deleteFeatured(record._id || record.id)}
                >
                  Yes
                </Button>
              </div>
            }
            title="Please Double click to delete."
          >
            <Button
              className="table_pill_btn table_pill_btn--danger"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Button onClick={showModal} className="add_button">
          Add New Featured Item
        </Button>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTableFeatured;
